import { computed } from 'vue'
import { usePrimeVue } from 'primevue/config'
import {
  i18n,
  loadLocaleMessages,
  hydrateFromCache,
  persistLocale,
  SUPPORTED_LOCALES,
  type AppLocale,
} from '@/i18n'
import { PRIMEVUE_LOCALES } from '@/i18n/primevueLocales'

/** Etichette del selettore lingua. */
export const LOCALE_LABELS: Record<AppLocale, string> = {
  it: 'Italiano',
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
}

/**
 * Composable per leggere/cambiare la lingua dell'interfaccia.
 *
 * Al cambio lingua: persiste in localStorage, idrata dalla cache (istantaneo), aggiorna il
 * locale vue-i18n e il locale PrimeVue, infine ricarica il bundle aggiornato dall'API.
 */
export function useLocale() {
  const primevue = usePrimeVue()

  const locale = computed<AppLocale>(() => i18n.global.locale.value as AppLocale)

  async function setLocale(lang: AppLocale): Promise<void> {
    persistLocale(lang)
    hydrateFromCache(lang)
    i18n.global.locale.value = lang
    // Aggiorna il locale PrimeVue (DataTable/Calendar/ecc.) mutando l'oggetto reattivo.
    const pv = PRIMEVUE_LOCALES[lang]
    if (primevue?.config?.locale && pv) {
      Object.assign(primevue.config.locale, pv)
    }
    await loadLocaleMessages(lang)
  }

  return {
    locale,
    setLocale,
    locales: SUPPORTED_LOCALES,
    labels: LOCALE_LABELS,
  }
}
